module.exports = __webpack_public_path__ + "img/arrrow-right.7b9f1843.svg";